import React from 'react';
import moment from 'moment';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMRestClient from 'lib/SMRestClient';
import SMTrackHelper from 'components/helpers/SMTrackHelper';

class SMOSalesListView extends React.Component {
  constructor(props) {
    super(props);
    
    // 振り込み期間を初期化
    let start_of_transfer_at, end_of_transfer_at = null;
    
    start_of_transfer_at = moment(new Date()).format("YYYYMMDD");
    
    let dt = new Date();
    dt.setDate(dt.getDate() + 7);
    end_of_transfer_at = moment(dt).format("YYYYMMDD");
    
    this.state = {
      sales: null,
      owner: this.props.owner,
      start_of_transfer_at: start_of_transfer_at,
      end_of_transfer_at: end_of_transfer_at,
      ended: "",
      errors: "",
      currentPage: 1,
      totalCount: 0,
      links: ""
    };

    this.queries = {
      start_of_transfer_at: start_of_transfer_at,
      end_of_transfer_at: end_of_transfer_at,
      ended: ""
    };
  }

  componentWillMount() {
    this.requestResource();
  }
    
  componentDidMount() {
    const self = this;
    $(".js-datepicker").datepicker({dateFormat:"yymmdd", onSelect:function(){
      self.queries[this.name] = this.value;
      self.setState(self.queries);
      self.requestResource();
    }});
  }
  
  pageDidSelect(page, e) {
    e.preventDefault();
    this.setState({
      currentPage: page
    });
    setTimeout(()=>{
      this.requestResource();
    }, 1);
    SMTrackHelper.pageView();
  }
  
  didChangeValue(e) {
    e.preventDefault();
    this.queries[e.currentTarget.name] = e.currentTarget.value;
    this.setState(this.queries);
    this.requestResource();
  }
  
  requestResource() {
    this.queries["page"] = this.state.currentPage;
    SMOwnerResource.getOwnerSales(this.props.owner.id, this.queries, (response, error, xhr)=>{
      this.setState({
        errorMessage: xhr.responseJSON.message,
      });
      if(!response) return;
      const links = SMRestClient.getLinks(xhr);
      if (links["next"]) {
        this.canRequest = true;
      }
      this.setState({
        sales: response,
        totalCount: xhr.getResponseHeader("X-List-Total-Count"),
        currentPage: this.state.currentPage,
        links: links,
      });
    });    
  }
  
  renderErrorMessage() {
    if(!this.state.errorMessage) return false;
    return (
      <p className="mb15 is-error"><i className="fa fa-exclamation-circle mr5"></i>{this.state.errorMessage}</p>
    );
  }
  
  renderPagerView() {
    return(
      <div className="ta-c">
        <SMSearchPagerView 
          delegate={this}
          perPage={20}
          totalCount={this.state.totalCount}
          currentPage={this.state.currentPage}
          links={this.state.links} />
      </div>
    );
  }
  
  renderBillingList(owner, sales) {
    if(!sales || !sales.billings.length ) return false;
    const billings = sales.billings;
    const rows = [];
    
    billings.forEach((billing, idx) => {
      rows.push(
        <div className="dashboard-sales__list clearfix">
          <p className="dashboard-sales__list-schedule">{billing.transfer_date}</p>
          <p className="dashboard-sales__list-method">{billing.payment_method_text}</p>
          <p className="dashboard-sales__list-user">
            <a href={Routes.owner_dashboard_reservation_path(owner.username, billing.reservation_id)}><img src={billing.user_profile_image} alt={billing.user_contact_name} className="dashboard-sales__list-user-icon" /></a>
            <a href={Routes.owner_dashboard_reservation_path(owner.username, billing.reservation_id)} className="link-hover-border dashboard-sales__list-user-name">{billing.user_contact_name}</a>
          </p>
          <p className="dashboard-sales__list-use">{billing.reserved_date_text}</p>
          <p className="dashboard-sales__list-price">{billing.total_pay_amount}</p>
        </div>
      );
    });

    return rows;
  }
  
  render() {
    const owner = this.props.owner;
    const sales = this.state.sales;
    
    return(
      <div className="dashboard-container clearfix mb30">
        <form>
          <div className="dashboard-maincol dashboard-sales">
            <h2 className="dashboard-title mb20">売上明細</h2>
            <div className="dashboard-sales__header">
              <p className="dashboard-sales__header-term">
                表示対象<span className="form-select__inner ml10 mr30">
                  <label className="form-select">
                    <select name="ended" onChange={this.didChangeValue.bind(this)}>
                      <option selected="selected" value="">すべての予約</option>
                      <option value="lt">完了した予約</option>
                      <option value="gte">今後の予約</option>
                    </select>
                  </label>
                </span>
              </p>
              <p className="dashboard-sales__header-term">
                振込期間（31日以内）<input placeholder={this.state.start_of_transfer_at} name="start_of_transfer_at" type="text" className="js-datepicker form-text form-sales-term" value={this.state.start_of_transfer_at} />
              〜<input placeholder={this.state.end_of_transfer_at} name="end_of_transfer_at" type="text" className="js-datepicker form-text form-sales-term" value={this.state.end_of_transfer_at} />
              </p>
              <p className="dashboard-sales__header-receipt"><a href={Routes.monthly_list_owner_dashboard_sales_path({owner_id: this.props.owner.id})}>支払通知書一覧</a></p>
            </div>

            {this.renderErrorMessage()}
            <div className="dashboard-sales__box">
              <div className="dashboard-sales__list dashboard-sales__list-title clearfix">
                <div className="dashboard-sales__list-box">
                  <p className="dashboard-sales__list-schedule">振込予定日</p>
                  <p className="dashboard-sales__list-method">支払方法</p>
                  <p className="dashboard-sales__list-user">詳細</p>
                  <p className="dashboard-sales__list-price">振込金額</p>
                </div>
              </div>
              {this.renderBillingList(owner, sales)}                
              <div className="dashboard-sales__list dashboard-sales__list-sum clearfix">
                <p className="fl">合計</p>
                <p className="fr">{!sales ? null : sales.total_pay_amount_text}</p>
              </div>
            </div>
            
            {this.renderPagerView()}
          </div>
        </form>
      </div>
    );
  }
}
export default SMOSalesListView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/sales/SMOSalesListView.jsx